export enum SettingsPlaybooksDataEventObjectsEnum {
  PLAYBOOK_CREATION_START = 'playbook_creation_start',
  PLAYBOOK_CREATION_SAVE = 'playbook_creation_save',
  PLAYBOOK_EDIT = 'playbook_edit',
  PLAYBOOK_DELETE = 'playbook_delete',
  PLAYBOOK_ADD_STEP = 'playbook_add_step',
  PLAYBOOK_TOGGLE_INFO_BAR = 'playbook_toggle_info_bar',
}
